export const HERO_TYPES = {
  Profile: "Profile",
  Welcome: "Welcome",
  Academy: "Academy",
  Custom: "Custom",
  Progress: "Progress",
};
